{
    "description": "Defines the schema for Stylesheet.",
    "type": "object",
    "properties": {
        "libraryId": {
            "description": "The identifier of the Library that Stylesheet belongs to",
            "minLength": 3,
            "maxLength": 64,
            "type": "string"
        },
        "id": {
            "description": "The identifier of the Stylesheet",
            "minLength": 3,
            "maxLength": 64,
            "type": "string"
        },
        "source": {
            "description": "The source of the Stylesheet"
        },
        "formatVersion": {
            "description": "The format version of the Stylesheet.",
            "minimum": 0,
            "type": "integer"
        },
        "status": {
            "description": "The status of the Stylesheet",
            "enum": [
                "draft",
                "published",
                "saved",
                "staged"
            ],
            "type": "string"
        },
        "revision": {
            "description": "The numeric revision of the Stylesheet.",
            "minimum": 0,
            "type": "integer"
        },
        "createdAt": {
            "description": "The timestamp the Stylesheet was created at",
            "type": "string",
            "format": "date-time"
        },
        "modifiedAt": {
            "description": "The timestamp when the Stylesheet was last modified at",
            "type": "string",
            "format": "date-time"
        }
    },
    "additionalProperties": false,
    "required": [
        "createdAt",
        "formatVersion",
        "id",
        "libraryId",
        "modifiedAt",
        "revision",
        "source",
        "status"
    ],
    "$schema": "http://json-schema.org/draft-07/schema#"
}
